import { render, staticRenderFns } from "./SyllabusesTable.vue?vue&type=template&id=36304fa4&scoped=true&"
import script from "./SyllabusesTable.vue?vue&type=script&lang=js&"
export * from "./SyllabusesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36304fa4",
  null
  
)

export default component.exports